package com.fireavert.units.add_new_unit_csv.data_models.requests

import com.fireavert.units.add_new_unit_client.data_models.requests.SimpleUnitCreationRequest
import kotlinx.serialization.Serializable

@Serializable
data class MultiUnitCreationRequest(
    val unitRequests: List<SimpleUnitCreationRequest>? = null
)